import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { ValueBreakdown } from './ui/ValueBreakdown';
import { FULL_MOCKUP_URL } from '../data/images';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const tomoNames = ['Tomo I — Defensa y Control', 'Tomo II — Ataque y Definición', 'Tomo III — Táctica y Estrategia', 'Tomo IV — Metodología y Planificación', 'Tomo V — Mentalidad, Negocio y Marca Personal'];
const baseBonoNames = ['Fichas de Pista', 'Radar del Alumno', 'Semáforo de Correcciones Rápidas', 'Planificador 30 Días', 'Vuelta a Pista'];
const kitExtraNames = ['El Mapa de Pista', 'Programador 12 Meses'];
export function PricingCards() {
  return <section id="oferta" className="bg-mp-black py-20 md:py-28 scroll-mt-20" data-id="element-189" data-mp="3thxshd49lsov">
      <Container data-id="element-190" data-mp="3oha4z1f8vtze">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-191" data-mp="3ogry7auyhxd8">
          <SectionTag tone="lime" data-id="element-192" data-mp="3jiqi8ystue5z">Maestro en Pista — pack completo</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-193" data-mp="3jkt5xc6ibv7j">
            Todo lo que necesitas, en un solo sistema.
          </h2>
        </div>

        <motion.img initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Maestro en Pista — 5 tomos, 5 bonos y Kit de Ejecución" width={640} height={640} loading="lazy" className="mx-auto mt-10 w-full max-w-[380px]" data-id="element-194" data-mp="g446091fjjqu" />

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-195" data-mp="u0q1xehqiyim">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-7 md:p-8" data-id="element-196" data-mp="2o93e37acq2in">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-197" data-mp="2jhbvbixft132">Maestro en Pista</p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-198" data-mp="25hkdf73sv0js">Incluye los 5 tomos + 5 bonos prácticos</p>

            <p className="mt-5 font-heading text-xs uppercase tracking-[0.15em] text-mp-lime" data-id="element-199" data-mp="2ajt602crg0ld">Los 5 tomos</p>
            <ul className="mt-2.5 space-y-2.5" data-id="element-200" data-mp="1vmscbtb0dvk9">
              {tomoNames.map(item => <CheckItem key={item} data-id="element-201" data-mp="20kkctbppyq02">{item}</CheckItem>)}
            </ul>

            <p className="mt-5 font-heading text-xs uppercase tracking-[0.15em] text-mp-lime" data-id="element-202" data-mp="3q0a0nij8mwgc">
              + Bonos de implementación
            </p>
            <ul className="mt-2.5 space-y-2.5" data-id="element-203" data-mp="1jagjwlvcq5t9">
              {baseBonoNames.map(item => <CheckItem key={item} data-id="element-204" data-mp="1ebn1cf17jom8">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-205" data-mp="1e9sl3e0vskoh" />

            <ValueBreakdown lines={[{
            label: 'Colección 5 Tomos',
            value: '35,50€'
          }, {
            label: 'Los 5 Bonos Estratégicos',
            value: '25,50€'
          }]} totalLabel="Valor total" totalValue="61€" finalPrice="16,90 €" discountPercent="72%" priceTone="white" data-id="element-206" data-mp="1t1kwxg1gvglg" />

            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="w-full" showArrow data-id="element-207" data-mp="2bznhnimzerdg">
              Quiero la versión base
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-208" data-mp="26yhoxktbn43x" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="relative flex flex-col rounded-2xl border-2 border-mp-lime bg-mp-card p-7 shadow-glow-lime md:p-8" data-id="element-209" data-mp="hlw8ek8ke9ij">
            <span className="absolute -top-3 left-7 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-210" data-mp="o2o1ubzvvsbl">
              Recomendado para monitores en activo
            </span>

            <p className="mt-2 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-211" data-mp="3rk66ybo9ul8b">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-212" data-mp="5av6wc197x18">Para tener el sistema + la infraestructura</p>

            <p className="mt-5 font-heading text-xs uppercase tracking-[0.15em] text-mp-lime" data-id="element-213" data-mp="a23gb82l3iee">
              Todo lo de la versión base
            </p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-214" data-mp="38pr7ym1ymskh">Los 5 tomos + los 5 bonos anteriores.</p>

            <p className="mt-5 font-heading text-xs uppercase tracking-[0.15em] text-mp-lime" data-id="element-215" data-mp="3dou2vdo87ieq">+ Kit de Ejecución</p>
            <ul className="mt-2.5 space-y-2.5" data-id="element-216" data-mp="1qu8ptj7r63ve">
              {kitExtraNames.map(item => <CheckItem key={item} data-id="element-217" data-mp="1qse5a60e8dru">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-218" data-mp="1lx8i73v98t26" />

            <ValueBreakdown lines={[{
            label: 'Todo lo anterior',
            value: '61€'
          }, {
            label: 'Kit de Ejecución',
            value: '25,90€'
          }]} totalLabel="Valor total" totalValue="86,90€" finalPrice="21,90 €" discountPercent="75%" priceTone="lime" data-id="element-219" data-mp="1gwua5ltnlj45" />
            <p className="-mt-4 mb-4 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-220" data-mp="y5teb6nty3ot">
              Solo 5 € más que la versión base
            </p>

            <CTAButton href={KIT_CHECKOUT_URL} className="w-full" showArrow data-id="element-221" data-mp="t8ksmw3h3hit">
              Quiero el sistema completo
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-222" data-mp="ej8bl7spg33x" />
          </motion.div>
        </div>
      </Container>
    </section>;
}